import {
  readCookieData,
} from './utils';
import {
  COOKIE_NAME,
} from './consts';

declare interface stringMap {
  [name: string]: string;
}

const mappingFromCookie: stringMap = {
  func: 'functional',
  anl: 'analytics',
  adv: 'advertising',
  dt3: 'dataToThirdParty',
  ess: 'essential',
};

export function getPolicyFromCookie() {
  const cookieData = readCookieData(COOKIE_NAME);
  if (!cookieData || typeof cookieData !== 'string') {
    return false;
  }

  let createdDate;
  const policy: any = {};
  try {
    const cookieJson = JSON.parse(decodeURIComponent(cookieData));
    Object.keys(mappingFromCookie).forEach((cookiePolicyKey) => {
      if (typeof cookieJson[cookiePolicyKey] === 'number') {
        const policyKey = mappingFromCookie[cookiePolicyKey];
        policy[policyKey] = cookieJson[cookiePolicyKey] === 1;
      }
    });

    createdDate = parseTimeStamp(cookieJson.ts);

    return {
      // TODO: REMOVE THIS HACK ONE PRODUCT EXPERIMENT ENDS - this is needed to support policy created by the test in the Tag Manager server
      defaultPolicy: !!cookieJson.temp,
      policy,
      createdDate,
    };
  } catch (e) {
    return false;
  }
}

export function parseTimeStamp(
  ts: string | number | undefined,
): Date | undefined {
  let createdDate;
  if (typeof ts === 'number') {
    createdDate = new Date(ts * 1000 * 60);
  }
  return createdDate;
}

export function clone(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

export { mappingFromCookie };
